import SYNC_SETTING_TABS from '../../models/syncSettingTabs';

const aeriesFormat = 'Aeries';
const oneRoster = 'OneRoster';
const oneRosterApi = 'OneRosterApiV1';
const buip = 'Buip';
const unmanaged = 'Manual';

const TAB_CHANGED_EVENT = 'syncSettingsTabChanged';
const REFRESH_ON_SHOW_EVENT = 'refreshOnShow';

class SyncSettingsController {
  constructor($stateParams, $state, agentConfigService, $rootScope, $scope, roleService) {
    this.name = 'syncSettings';
    this.$state = $state;
    this.agentConfigService = agentConfigService;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.roleService = roleService;
    this.agentConfig = {};
    this.activateTab($stateParams.tabName);
    this.getAgentConfig();
    this.listenForChangeTabEvents();
  }

  isUserAdmin() {
    return this.roleService.looksLikeAdminAsCustomer();
  }

  getAgentConfig() {
    this.agentConfigService.getAgentConfig().then(
      this.onGetAgentConfigSuccess.bind(this),
      this.onGetAgentConfigFailure.bind(this)
    );
  }

  onGetAgentConfigSuccess(response) {
    let agentConfig = response.data.content;
    this.agentConfig = agentConfig;
  }

  onGetAgentConfigFailure() {
    console.log('There was an error retrieving your agent configuration.');
  }

  activateTab(tabName) {
    let activeTabProperty = SYNC_SETTING_TABS[tabName].activeTabProperty;
    this[activeTabProperty] = true;
  }

  clearActiveTabs() {
    this.scheduleTabActive = false;
    this.fileUploadTabActive = false;
  }

  setActiveTabFromClick(tabName) {
    this.activateTab(tabName);
    this.$state.go(this.$state.current, {
      tabName: tabName
    },{
      notify: false,
      reload: this.$state.current
    });
  }

  isAeriesCustomer() {
    return (this.agentConfig.format === aeriesFormat);
  }

  isOneRosterCustomer() {
    return (this.agentConfig.format === oneRoster);
  }

  isOneRosterApiCustomer() {
    return (this.agentConfig.format === oneRosterApi);
  }

  isBuipCustomer() {
    return (this.agentConfig.format === buip);
  }

  isUnmanaged () {
    return (this.agentConfig.format === unmanaged);
  }

  listenForChangeTabEvents() {
    this.$rootScope.$on(TAB_CHANGED_EVENT, (event, tabName) => {
      if(tabName) {
        this.activateTab(tabName);
      }
    });
  }

  refreshUploadHistory() {
    this.$scope.$broadcast(REFRESH_ON_SHOW_EVENT, {});
  }
}

SyncSettingsController.$inject = ['$stateParams', '$state', 'agentConfigService', '$rootScope', '$scope', 'roleService'];

export default SyncSettingsController;



// WEBPACK FOOTER //
// ./app/components/syncSettings/syncSettings.controller.js